import { useAppDispatch } from "core/utils";
import { useParams } from "react-router";

import { CardProfileEditForm } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/components/forms/CardProfileEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../../../core/router/auth";
import { ResourceName, ResourceVariant } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../../../core/setup/redux/state/tabs/tabState";

export const CardProfileApacEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();

    const { appProfileId, id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/app-profiles/${appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${id}/${FORM_ACTION.HISTORY}`;
    const backUrl = `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${ResourceVariant.APAC}/${FORM_ACTION.EDIT}/${appProfileId}`;

    const dispatch = useAppDispatch();
    const setTabsDefaultBeforeBack = () => dispatch(setDefaultActiveKey("applications-profiles_cardProfiles"));

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardProfilesApacEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={backUrl} onBeforeNavigate={setTabsDefaultBeforeBack} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardProfileEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
